import { useAppDispatch, useAppSelector } from "../../../util/hooks"
import SingleSelection from "../../../components/Filters/SingleSelection"
import {
  marketFilterChange,
  marketSingleFilterOptionsAsync,
  pipeLineFilterChange,
  pipelineFilterOptionsAsync,
  monitorUseCaseFilterChange,
  monitorUseCaseFilterOptionsAsync,
} from "../MonitorSlice"
import UseCase from "../../../icons/usecase.svg"
import Market from "../../../icons/market.svg"
import PipeLine from "../../../icons/singlepipeline.svg"

import { createUseStyles, useTheme } from "react-jss"
import React from "react"

const useStyles = createUseStyles({
  filterContainer: {
    gap: 13,
    alignItems: "center",
    display: "grid",
    gridTemplateColumns: "20px 75px 1fr",
  },
  filterWrapper: {
    display: "flex",
    flexDirection: "column",
    minHeight: "210px",
    gap: 24,
  },
  label: {
    color: "var(--dark-neutrals-dark, #333)",
    fontFamily: ({ theme }: any) => theme.primaryFontFamily,
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: 500,
    justifySelf: "flex-end",
    lineHeight: "150%", // You can keep this as a string or convert it to '1.5' for 150%
    maxWidth: (props: any) => {
      return props["maxWidth"]
    },
  },
  market: {},
  pipeline: {},
})
export const NewPipeLineDetails = () => {
  const dispatch = useAppDispatch()

  // Selector to get the currently selected values for filters
  const useCaseSelectedValue = useAppSelector(
    (state) => state.monitor.newPipeLine.filters.useCase.selectedValue,
  )
  const optionsUseCase = useAppSelector(
    (state) => state.monitor.newPipeLine.filters.useCase.filterOptions,
  )

  const pipelineSelectedValue = useAppSelector(
    (state) => state.monitor.newPipeLine.filters.pipeline.selectedValue,
  )
  const pipelineOptions = useAppSelector(
    (state) => state.monitor.newPipeLine.filters.pipeline.filterOptions,
  )

  const [filteredPipelineOptions, setFilteredPipelineOptions] =
    React.useState(pipelineOptions)

  const marketSelectedValue = useAppSelector(
    (state) => state.monitor.newPipeLine.filters.market.selectedValue,
  )
  const marketOptions = useAppSelector(
    (state) => state.monitor.newPipeLine.filters.market.filterOptions,
  )

  const theme: any = useTheme()

  React.useEffect(() => {
    if (useCaseSelectedValue !== "" && marketSelectedValue !== "") {
      const options = pipelineOptions.filter(
        (option: any) =>
          option.useCase === useCaseSelectedValue &&
          option.marketPlace === marketSelectedValue,
      )

      setFilteredPipelineOptions(options)
    }
  }, [useCaseSelectedValue, marketSelectedValue, dispatch])

  // Effect to fetch filter options if they are not already available
  React.useEffect(() => {
    if (!pipelineOptions.length) {
      dispatch(pipelineFilterOptionsAsync())
    }
    if (!marketOptions.length) {
      dispatch(marketSingleFilterOptionsAsync())
    }
    if (!optionsUseCase.length) {
      dispatch(monitorUseCaseFilterOptionsAsync())
    }
  }, [dispatch, pipelineOptions, marketOptions, optionsUseCase]) // Adding dependencies to avoid stale closures

  const classes = useStyles({ theme })

  return (
    <div className={classes.filterWrapper}>
      {/* Use Case Filter */}
      <div className={classes.filterContainer}>
        <img src={UseCase} alt="Use Case" />
        <div className={classes.label}> Use Case: </div>
        <div>
          <SingleSelection
            minWidth={300}
            maxWidth={300}
            changeFunc={(value: string) =>
              dispatch(monitorUseCaseFilterChange(value))
            }
            filterValue={useCaseSelectedValue}
            options={optionsUseCase}
            label="Use Case"
            showLabel={false}
          />
        </div>
      </div>

      {/* Market Filter */}
      <div className={classes.filterContainer}>
        <img src={Market} alt="Market" />
        <div className={`${classes.label} ${classes.market}`}> Market: </div>
        <div>
          <SingleSelection
            minWidth={300}
            maxWidth={300}
            changeFunc={(value: string) => dispatch(marketFilterChange(value))}
            filterValue={marketSelectedValue}
            options={marketOptions}
            label="Market"
            showLabel={false}
          />
        </div>
      </div>

      {/* Pipeline Filter */}
      <div className={classes.filterContainer}>
        <img src={PipeLine} alt="Pipeline" />
        <div className={`${classes.label} ${classes.pipeline}`}>Pipeline:</div>
        <div>
          <SingleSelection
            minWidth={300}
            maxWidth={300}
            changeFunc={(value: string) =>
              dispatch(pipeLineFilterChange(value))
            }
            maxMenuHeight={90}
            filterValue={pipelineSelectedValue}
            options={filteredPipelineOptions}
            label="Pipeline"
            showLabel={false}
            isDisabled={
              marketSelectedValue === "" || useCaseSelectedValue === ""
            }
          />
        </div>
      </div>
    </div>
  )
}
